fieldNameFromStoreName